import { useTranslation } from 'react-i18next';
import { ColumnDef } from '@tanstack/react-table';
import { BaseModalProps } from '@anytag/shared-atoms';
import { formatIntNumber } from '@anytag/shared-utils';
import { InstagramPopularHashtags } from '@anytag/graphql';
import { InfluencerAvatar } from '@anytag/shared-molecules';
import { TableCell, TextCutter, TableV2, BaseModal } from '@anytag/shared-atoms';

export interface AnalyticsCompareInstagramHashtagsModalProps extends BaseModalProps {
  hashtags?: readonly InstagramPopularHashtags[];
  account?: { name?: string; avatar?: string };
}

export const AnalyticsCompareInstagramHashtagsModal = ({
  account,
  footer: actions,
  onClose,
  hashtags = [],
  ...restProps
}: AnalyticsCompareInstagramHashtagsModalProps) => {
  const { t } = useTranslation();
  const columns: ColumnDef<InstagramPopularHashtags>[] = [
    {
      accessorKey: 'hashtag',
      header: t<string>('HeaderColumn.Hash Tag'),
      cell: ({ row }) => <TableCell.Text className="min-w-0" value={row.original.hashtag} />
    },
    {
      accessorKey: 'usedPosts',
      header: t<string>('HeaderColumn.Used Post'),
      meta: { align: 'right' },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.usedPosts)} />
    },
    {
      accessorKey: 'averageLikes',
      header: t<string>('HeaderColumn.Ave like'),
      meta: { align: 'right' },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.averageLikes)} />
    },
    {
      accessorKey: 'averageComments',
      header: t<string>('HeaderColumn.Ave Comment'),
      meta: { align: 'right' },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.averageComments)} />
    },
    {
      accessorKey: 'averageEngagement',
      header: t<string>('HeaderColumn.Ave Eng'),
      meta: { align: 'right' },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.averageEngagement)} />
    }
  ];

  return (
    <BaseModal
      onClose={onClose}
      footer={{ ...actions, cancelButton: { onClick: onClose, ...actions?.cancelButton } }}
      title={
        <div className="flex items-center">
          <InfluencerAvatar size="24px" src={account?.avatar} className="mr-2 rounded-full" />
          <TextCutter lines={1} text={t('Dialog.PostingHabits', { name: account?.name })} />
        </div>
      }
      {...restProps}
    >
      <TableV2 className="border border-border" data={hashtags} columns={columns} noTopBorderRadius />
    </BaseModal>
  );
};
